import { defineMessages } from 'react-intl';

export default defineMessages({
  nameDialogTitle: { id: 'accountSwitcher.nameDialogTitle', defaultMessage: 'Name this account' },
  nameCurrentTitle: {
    id: 'accountSwitcher.nameCurrentTitle',
    defaultMessage: 'Name your current account',
  },
  nameLabel: { id: 'accountSwitcher.nameLabel', defaultMessage: 'Account name' },
  duplicateName: {
    id: 'accountSwitcher.duplicateName',
    defaultMessage: 'That name is already in use',
  },
  save: { id: 'accountSwitcher.save', defaultMessage: 'Save' },
  cancel: { id: 'accountSwitcher.cancel', defaultMessage: 'Cancel' },
  switchAccountHeading: {
    id: 'accountSwitcher.switchAccountHeading',
    defaultMessage: 'Switch account',
  },
  addAccount: { id: 'accountSwitcher.addAccount', defaultMessage: 'Add account' },
  rename: { id: 'accountSwitcher.rename', defaultMessage: 'Rename' },
  remove: { id: 'accountSwitcher.remove', defaultMessage: 'Remove account' },
  removeTitle: { id: 'accountSwitcher.removeTitle', defaultMessage: 'Remove account?' },
  removeCta: { id: 'accountSwitcher.removeCta', defaultMessage: 'Remove' },
  removeNonActive: {
    id: 'accountSwitcher.removeNonActive',
    defaultMessage:
      'You will be signed out of "{label}" and it will be removed from your accounts.',
  },
  removeActiveSwitch: {
    id: 'accountSwitcher.removeActiveSwitch',
    defaultMessage:
      '"{label}" is the account you are currently using. Removing it will end this session and switch you to "{next}".',
  },
  removeActiveLogout: {
    id: 'accountSwitcher.removeActiveLogout',
    defaultMessage:
      '"{label}" is the account you are currently using, and your only one. Removing it will end this session and return you to the login screen.',
  },
});
